import{
  OS,
} from "./stores.js";
import { get } from "svelte/store";

let alertInterval
let audioInterval

export function toggleAlertAudio(alertOn) {
    setNotificationStatus(alertOn);
    if (alertOn) {
        if (alertInterval) return;

        alertInterval = setInterval(() => {
            let audio = new Audio("../audio/mixkit-positive-notification-951.mp3");
            audio.play(); //todo: try catch exception, if fails to play show UI warning
        }, 3000);
    } else {
        if (!alertInterval) return;

        clearInterval(alertInterval);
        alertInterval = null;
    }
}

function setNotificationStatus(alertOn) {
    if ("mediaSession" in navigator) {
        navigator.mediaSession.metadata = new MediaMetadata({
            title: "Pickapp",
            artist: alertOn ? "התקבלה הזמנה חדשה" : "ממתין להזמנות"
        });
    }
}

export function startAudioLoop() {
    if (window.cordova) return;
    audioElement.currentTime = 0;
    audioElement.play();
    audioInterval = setInterval(() => {
        audioElement.play();
    }, 1000 * 35); // length of the silent audio

    if ("mediaSession" in navigator) {
        navigator.mediaSession.playbackState = "playing";
        setNotificationStatus(false)


        navigator.mediaSession.setActionHandler("pause", function () {
            if (!audioInterval) return;
            clearInterval(audioInterval);
            audioInterval = null;
            audioElement.pause();
            audioElement.src = "";
            getNotifications = false;
        });
    }
}

var audioElement = document.createElement('audio');
audioElement.controls = 'controls';
audioElement.src = 'audio/longsilent.mp3';
audioElement.type = 'audio/mpeg';
audioElement.style = 'display:none;';
document.body.appendChild(audioElement);
